export default __webpack_public_path__ + "static/media/warning--road-toll-ahead--g1.6d55961a.png";